import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { EVENT_EDITMODE_CHANGED, GA1Service } from '../ga1/ga1.service';
import { IGAEvent } from '../services/ga-event.service';

import * as _ from 'underscore';
import { EditableTextDialogComponent } from './editable-text-dialog.component';
import { GaStateService, TranslationCategory } from '../services/ga-state.service';
import { ITranslate } from '../translation/translate-data.service';
import { TranslateService } from '@ngx-translate/core';
import { GaMessageService, IDialog } from '../message/ga-message.service';
import { util } from '../util';
import { EditableTextService, IEditableTextOption } from './editable-text.service';

@Component({
  selector: 'editable-text',
  template: `
		<span *ngIf="editMode" class="btn-group editable-text" dropdown>
      <a href="javascript:void(0)" id="editable-text-menu" dropdownToggle><i class="fa fa-pencil"></i></a>
      <ul class="dropdown-menu" *dropdownMenu aria-labelledby="editable-text-menu">
        <li *ngFor="let option of menuOptions">
          <a href="javascript:void(0)" (click)="openEditDialog(option)">{{option.name}}</a>
        </li>
      </ul>
    </span>
	`,
  styleUrls: ['./editable-text.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditableTextComponent implements OnInit {
  public menuOptions:any[];
  public editMode:boolean;
  public open:boolean;

  @Input() public key:string;
  @Input() public menu:string;
  @Input() public initValues:any;
  @Input() public category:TranslationCategory;
  @Input() public screen:string;
  @Input() public highlight:string;
  @Input() public customMenu:IEditableTextOption[];

  @Output() public onModeChange:EventEmitter<boolean> = new EventEmitter();

  private possibleMenuItems:IEditableTextOption[] = [
    {
      id: 'text',
      name: 'Edit text'
    },
    {
      id: 'title',
      name: 'Edit title'
    },
    {
      id: 'label',
      name: 'Edit label'
    },
    {
      id: 'info',
      name: 'Edit info'
    },
    {
      id: 'placeholder',
      name: 'Edit placeholder'
    }
  ];

  constructor(
    private ga1Service:GA1Service,
    private elementRef:ElementRef,
    private gaStateService:GaStateService,
    private translateService:TranslateService,
    private messageService:GaMessageService,
    private editableTextService:EditableTextService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.updateEditMode();

    const allowedMenuItems:string[] = this.menu?.split(',');
    this.menuOptions = [];
    _.each(this.possibleMenuItems, (menuItem:IEditableTextOption) => {
      if (allowedMenuItems.indexOf(menuItem.id) >= 0) {
        this.menuOptions.push(menuItem);
      }
    });

    // when custom menu is provided then use custom menu instead default options
    if (this.customMenu) {
      this.menuOptions = [];
      _.each(this.customMenu, (menuItem:IEditableTextOption) => {
        this.menuOptions.push(menuItem);
      });
    }

    // register listener
    this.listen();
  }

  public openEditDialog(option:IEditableTextOption):void {
    const dialog:IDialog = this.messageService.showDialog({
      component: EditableTextDialogComponent,
      wrapperComponent: false,
      inputs: {
        key: option.key || this.key,
        option,
        category: this.category || this.gaStateService.currentTranslationCategory,
        screen: this.screen || this.gaStateService.screen,
        initValue: this.initValues?.[option.id],
        languageId: this.translateService.currentLang
      },
      outputs: {
        onCancel: () => dialog.hide(),
        onSaved: (data:ITranslate) => {
          const translations:any = this.translateService.translations[ this.translateService.currentLang ];

          if (translations[data.key]) {
            translations[ data.key ] = data.text;
          } else {
            util.setValue(translations, data.key, data.text);
          }

          this.translateService.setTranslation(this.translateService.currentLang, translations);
          this.messageService.showFeedbackMessage('Text saved');

          dialog.hide();
        },
        onDeleted: (data:ITranslate) => {
          const translations:any = this.translateService.translations[ this.translateService.currentLang ];

          if (translations[data.key]) {
            delete translations[ data.key ];
          } else {
            util.setValue(translations, data.key, this.editableTextService.getFullKey(this.key, this.screen, option?.id));
          }

          this.translateService.setTranslation(this.translateService.currentLang, translations);
          this.messageService.showFeedbackMessage('Text deleted');

          dialog.hide();
        }
      }
    });
  }

  private listen():void {
    this.ga1Service.events.subscribe((e:IGAEvent) => {
      if (e.name === EVENT_EDITMODE_CHANGED) {
        this.updateEditMode();
      }
    });
  }

  private updateEditMode():void {
    this.editMode = _.clone(this.ga1Service.editMode);
    this.onModeChange.emit(this.editMode);

    setTimeout(() => {
      let highlightElement:JQuery<HTMLElement> = $(this.elementRef.nativeElement).parent();
      let highlightSelector:string = this.highlight;

      // for each 'parent' that we encounter, go up a level
      while (highlightSelector.indexOf('parent') >= 0) {
        highlightElement = highlightElement.parent();
        highlightSelector = highlightSelector.replace('parent', '');
      }

      highlightElement = highlightElement.find(highlightSelector);

      if (this.editMode) {
        highlightElement.addClass('highlight');
      } else {
        highlightElement.removeClass('highlight');
      }
    });
  }
}